import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import {
  Aangifte,
  AangifteBerekening,
  AanslagIb,
  AanslagIbAanslagSoort, BokkzAlgDataService,
  Box1Berekening,
  Box2Berekening,
  Box3Berekening,
  HeffingskortingenBerekening, IncomeTaxEntity,
  OpbouwBox1,
  OpbouwBox2,
  OpbouwBox3,
  OpbouwHeffingskortingen,
  OpbouwPGA
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BokkzIbDataService  } from "@snelstart-ventures/fiscaal/domain-logic";
import {FormBuilder, FormGroup} from "@angular/forms";
import { BehaviorSubject, filter, Subscription } from "rxjs";
import { Event, NavigationEnd, Router } from "@angular/router";
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-aanslagen',
  templateUrl: './aanslagen.component.html',
  styleUrls: ['./aanslagen.component.scss'],
  imports: [
    SharedUiFormControlsModule,
    SharedUiDetailsModule,
    DatePipe
  ]
})
export class AanslagenComponent implements OnInit, OnDestroy {
    private routerSubscription: Subscription | undefined;
    private berekeningSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private isSaving = false;
    private clientId!: string;

    public aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    @Input() partner = new BehaviorSubject<boolean>(false);

    public berekeningFormGroup = this.fb.group<AangifteBerekening>({});
    public aanslagIbFormGroup = {} as FormGroup;
    public berekening = {} as AangifteBerekening;

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService,
                private router: Router,
                private fb: FormBuilder) {
        this.berekeningFormGroup = this.fb.group<AangifteBerekening>({
            box1: this.fb.group<Box1Berekening>({
                inkomen: null as unknown as number,
                persoonsgebondenAftrek: null as unknown as number,
                belastbaarInkomen: null as unknown as number,
                inkomstenbelasting: null as unknown as number,
                conserverendeAanslag: null as unknown as number,
                opbouwInkomen: this.fb.group<OpbouwBox1>({
                    winstUitOnderneming: null as unknown as number,
                    belastbaarloon: null as unknown as number,
                    resultaatUitOverigeWerkzaamheden: null as unknown as number,
                    periodiekeUitkeringen: null as unknown as number,
                    inkomstenUitEigenWoning: null as unknown as number,
                    saldoEigenWoning: null as unknown as number,
                    negatieveUitgavenVoorInkomensvoorzieningen: null as unknown as number,
                    negatievePersoonsgebondenAftrek: null as unknown as number,
                    overigeInkomsten: null as unknown as number,
                    aftrekWegensGeenOfGeringeEigenWoningSchuld: null as unknown as number,
                    uitgavenVoorInkomensvoorzieningen: null as unknown as number,
                    verrekendVerlies: null as unknown as number,
                }),
            }),
            box2: this.fb.group<Box2Berekening>({
                inkomen: null as unknown as number,
                persoonsgebondenAftrek: null as unknown as number,
                belastbaarInkomen: null as unknown as number,
                inkomstenbelasting: null as unknown as number,
                conserverendeAanslag: null as unknown as number,
                opbouwInkomen: this.fb.group<OpbouwBox2>({
                    inkomenUitAanmerkelijkBelang: null as unknown as number,
                    verrekendVerlies: null as unknown as number,
                    saldoAanmerkelijkBelang: null as unknown as number,
                }),
            }),
            box3: this.fb.group<Box3Berekening>({
                inkomen: null as unknown as number,
                persoonsgebondenAftrek: null as unknown as number,
                belastbaarInkomen: null as unknown as number,
                inkomstenbelasting: null as unknown as number,
                opbouwInkomen: this.fb.group<OpbouwBox3>({
                    voordeelUitSparenEnBeleggen: null as unknown as number,
                    grondslagNaVerdeling: null as unknown as number,
                    grondslagSparenEnBeleggen: null as unknown as number,
                    waardeBezittingenBinnenlandsePeriode: null as unknown as number,
                    waardeSchuldenBinnenlandsePeriode: null as unknown as number,
                    waardeBezittingenBuitenlandsePeriode: null as unknown as number,
                    waardeSchuldenBuitenlandsePeriode: null as unknown as number,
                    rendementsGrondslagBinnenlandsePeriode: null as unknown as number,
                    rendementsGrondslagBuitenlandsePeriode: null as unknown as number,
                    drempelSchuldenBinnenlandsePeriode: null as unknown as number,
                    drempelSchuldenBuitenlandsePeriode: null as unknown as number,
                    grondslagBinnenlandsePeriode: null as unknown as number,
                    grondslagBuitenlandsePeriode: null as unknown as number,
                    aandeelGrondslagBinnenlandsePeriode: null as unknown as number,
                    aandeelGrondslagBuitenlandsePeriode: null as unknown as number,
                    voordeelSparenEnBeleggenVoorVerminderingBinnenlandsePeriode: null as unknown as number,
                    voordeelSparenEnBeleggenVoorVerminderingBuitenlandsePeriode: null as unknown as number,
                    eldersBelasteRechtenOnroerendeZakenBuitenland: null as unknown as number,
                    verminderingVanwegeEldersBelasteRechtenBuitenland: null as unknown as number,
                    bezittingenDieMeetellenVoorTijdsevenredigeHerleidingBinnenlandsePeriode: null as unknown as number,
                    verminderingVoordeelTijdevenredigeHerleiding: null as unknown as number,
                    voordeelUitSparenEnBelegenBinnenlandsePeriode: null as unknown as number,
                    voordeelUitSparenEnBelegenBuitenlandsePeriode: null as unknown as number,
                }),
            }),
            premieVolksverzekeringen: null as unknown as number,
            gecombineerdeInkomensheffing: null as unknown as number,
            opbouwPGA: this.fb.group<OpbouwPGA>({
                restantPgaVoorgaandeJaren: null as unknown as number,
                onderhoudsverplichtingen: null as unknown as number,
                specifiekeZorgkosten: null as unknown as number,
                weekenduitgaven: null as unknown as number,
                scholingsuitgaven: null as unknown as number,
                monumentenpanden: null as unknown as number,
                aftrekbareGiften: null as unknown as number,
                kwijtscheldingDurfkapitaal: null as unknown as number,
                aandeelPartnerPga: null as unknown as number,
            }),
            heffingskortingen: this.fb.group<HeffingskortingenBerekening>({
                totaal: 4000,
                opbouw: this.fb.group<OpbouwHeffingskortingen>({
                    algemeneHeffingskorting: null as unknown as number,
                    arbeidskorting: null as unknown as number,
                    inkomensafhankelijkeCombinatieKorting: null as unknown as number,
                    ouderenkorting: null as unknown as number,
                    alleenstaandeOuderenkorting: null as unknown as number,
                    wajong: null as unknown as number,
                    grondslagGroeneBeleggingen: null as unknown as number,
                    groeneBeleggingen: null as unknown as number,
                    levensloopverlof: null as unknown as number,
                    werkbonus: null as unknown as number,
                    vutkorting: null as unknown as number,
                    maximering: null as unknown as number,
                    verhogingPartner: null as unknown as number,
                })
            }),
            verrekendeBelastingKortingBox2: null as unknown as number,
            alBetaaldeLoonbelasting: null as unknown as number,
            alBetaaldeDividendbelasting: null as unknown as number,
            voorlopigeAanslag: null as unknown as number,
            aanslaggrens: null as unknown as number,
            verschuldigdeInkomstenbelasting: null as unknown as number,
            verschuldigdeZVW: null as unknown as number,
            nietToegerekendePga: null as unknown as number,
            verzamelinkomen: null as unknown as number,
        })
        this.aanslagIbFormGroup = this.fb.group<AanslagIb>({
            aangifteJaar: 2023,
            eenheidBelastingdienst: null as unknown as string,
            bsn: "110200111",
            aanslagnummer: "110200111H31",
            aanslagdatum: new Date('1-8-2023'),
            aanslagSoort: AanslagIbAanslagSoort.DEFINITIEVE_AANSLAG,
            middel: "Inkomstenbelasting",
            // middeling: {
            //     eersteJaarTijdvakMiddeling: null as unknown as number,
            //     tweedeJaarTijdvakMiddeling: null as unknown as number,
            //     derdeJaarTijdvakMiddeling: null as unknown as number,
            //     tijdigOntvangenVerzoekMiddeling: null as unknown as boolean,
            //     inkomenEersteJaarTijdvak: null as unknown as number,
            //     inkomenTweedeJaarTijdvak: null as unknown as number,
            //     inkomenDerdeJaarTijdvak: null as unknown as number,
            //     herleidPremieInkomenEersteJaar: null as unknown as number,
            //     herleidPremieInkomenTweedeJaar: null as unknown as number,
            //     herleidPremieInkomenDerdeJaar: null as unknown as number,
            //     gehevenInkomstenBelastingEersteJaar: null as unknown as number,
            //     gehevenInkomstenBelastingTweedeJaar: null as unknown as number,
            //     gehevenInkomstenBelastingDerdeJaar: null as unknown as number,
            //     gehevenPremiesEersteJaar: null as unknown as number,
            //     gehevenPremiesTweedeJaar: null as unknown as number,
            //     gehevenPremiesDerdeJaar: null as unknown as number,
            //     gemiddeldBelastbaarInkomen: null as unknown as number,
            //     gemiddeldPremieInkomen: null as unknown as number,
            //     herrekendeBelastingEersteJaar: null as unknown as number,
            //     herrekendeBelastingTweedeJaar: null as unknown as number,
            //     herrekendeBelastingDerdeJaar: null as unknown as number,
            //     herrekendePremieEersteJaar: null as unknown as number,
            //     herrekendePremieTweedeJaar: null as unknown as number,
            //     herrekendePremieDerdeJaar: null as unknown as number,
            //     somGehevenBelastingEnPremies: null as unknown as number,
            //     somHerrekendeBelastingEnPremies: null as unknown as number,
            //     verschilGehevenEnVerrekendeBelastingEnPremies: null as unknown as number,
            //     correctieTotAanGehevenBelasting: null as unknown as number,
            //     verschilNaCorrectie: null as unknown as number,
            //     drempelMiddeling: null as unknown as number,
            //     teruggaafVoorCorrectieDubbeleBelasting: null as unknown as number,
            //     correctieInVerbandMetVoorkomingDubbeleBelasting: null as unknown as number,
            //     teruggaaf: null as unknown as number,
            //     vorigeTeruggaaf: null as unknown as number,
            //     uitersteDatumBezwaar: null as unknown as Date,
            // },
            inkomenBox1: 80000,
            restantZelfstandigenAftrek: null as unknown as number,
            verliesJaarAchterwaartseVerliesVerrekening: null as unknown as number,
            nogTeVerrekenenOndernemingsVerliezenVoorgaandeJaren: null as unknown as number,
            geledenOndernemingsVerlies: null as unknown as number,
            verrekendOndernemingsVerlies: null as unknown as number,
            naDitJaarNietMeerTeVerrekenenOndernemingsVerliezen: null as unknown as number,
            nogTeVerrekenenGewoneVerliezen: null as unknown as number,
            geledenGewoonVerlies: null as unknown as number,
            verrekendGewoonVerlies: null as unknown as number,
            naDitJaarNietMeerTeVerrekenenGewoneVerliezen: null as unknown as number,
            belastbaarInkomenNaCarryBack: null as unknown as number,
            nogTeVerrekenVerliesBox1CarryBack: null as unknown as number,
            verrekendVerliesBox1CarryBack: null as unknown as number,
            eindstandVerliesBox1CarryBack: null as unknown as number,
            naDitJaarNietMeerVerrekenbaarVerlies: null as unknown as number,
            inkomenUitWerkEnWoningVerliesJaar: null as unknown as number,
            verrekendVerliesBox1: null as unknown as number,
            nogTeVerrekenenOndernemingsVerliezenBox1: null as unknown as number,
            nogTeVerrekenenOverigeVerliezenBox1: null as unknown as number,
            inkomenBox2: null as unknown as number,
            verrekendVerliesBox2: null as unknown as number,
            nogTeVerrekenVerliezenBox2VoorgaandeJaren: null as unknown as number,
            geledenBox2Verlies: null as unknown as number,
            verrekendBox2Verlies: null as unknown as number,
            nogTeVerrekenenVerliesBox2: null as unknown as number,
            belastbaarInkomenBox2NaCarryBack: null as unknown as number,
            inkomenBox2VerliesJaar: null as unknown as number,
            naDitJaarNietMeerTeVerrekenVerliesBox2: null as unknown as number,
            inkomenBox3: 39000,
            verzamelinkomen: 92000,
            belastingBox1: 42000,
            belastingBox2: null as unknown as number,
            belastingBox3: 13000,
            premiesVolksverzekeringen: 10000,
            heffingsKortingen: 3000,
            algemeneHeffingskorting: null as unknown as number,
            arbeidsKorting: null as unknown as number,
            iack: null as unknown as number,
            wajongKorting: null as unknown as number,
            ouderenKorting: null as unknown as number,
            alleenstaandeOuderenKorting: null as unknown as number,
            levensLoopVerlofKorting: null as unknown as number,
            groeneBeleggingenKorting: null as unknown as number,
            verrekendeDividendbelasting: null as unknown as number,
            verrekendeloonbelasting: 30000,
            verrekendeVoorlopigeAanslagen: null as unknown as number,
            vergrijpBoete: null as unknown as number,
            rente: 12,
            bedragVanDeAanslag: 9012,
            betalingsKorting: null as unknown as number,
            uitersteBetaalDatum: new Date('11-9-2023'),
            uitersteBetaalDatumMeerdereTermijnen: null as unknown as Date,
            uitersteBetaalDatumLaatsteTermijn: null as unknown as Date,
            uitersteDatumBezwaar: null as unknown as Date,
            uitersteDatumBeroep: null as unknown as Date,
            rendementsGrondslagVermogensToets: null as unknown as number,
            vrijstellingGroeneBeleggingenVermogensToets: null as unknown as number,
        })
    }

    public ngOnInit(): void {
      this.berekeningSubscription = this.dataService.aangifteBerekening.subscribe((value) => {
            this.berekening = value;
            this.berekeningFormGroup.patchValue(this.berekening);
        });
      this.incomeTaxEntitySubscription = this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
        this.incomeTaxEntity = incomeTaxEntity;
        if (incomeTaxEntity.aangifte) {
          const aangifte = incomeTaxEntity.aangifte as Aangifte;
        }
      });
      this.dataAlgService.client.subscribe((client) =>{
        this.clientId=client.sstRelationId!;
      })
      this.routerSubscription = this.router.events.pipe(filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          this.handleUrlChange(event.urlAfterRedirects);
        });
    }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
    }
    if (this.incomeTaxEntitySubscription) {
      this.incomeTaxEntitySubscription.unsubscribe();
    }
    if (this.clientEntitySubscription) {
      this.clientEntitySubscription.unsubscribe();
    }
    if (this.clientEntitySubscription) {
      this.clientEntitySubscription.unsubscribe(); // Unsubscribe from income tax entity
    }
    if (this.berekeningSubscription) {
      this.berekeningSubscription.unsubscribe(); // Unsubscribe from income tax entity
    }

  }
  handleUrlChange(newUrl: string) {
    if (!this.isSaving) {
      this.isSaving = true;
      this.dataService.postIncomeTaxEntity(this.clientId, false, this.incomeTaxEntity);
      this.isSaving = false;
    }
  }
}
